<template lang="pug">
include ../mixins
+b.ls-card--space_custom.--color_white.--border_3sm-adaptive.pos--relative
  ui-preloader(
    :class="{'is-active': isLoad}"
    loader-color='loader-wrapper__bg--accent-1'
    loader-class="loader--variant_absolute"
  )
  +b.modal-close--common.BUTTON(
    tabindex="-1"
    @click="$emit('close')"
  )
  +b.ma--top_3xs-xxl.--bottom_3sm
    +b.P.ls-text.--size_2sm.--weight_semi-bold.--height_md.--variant_center {{ _("Выберите сумму которую хотите оплатить") }}
  +b.g-row.--appearance_spaced
    +b.g-cell.g-cols--12(v-for="item in objectItem.transactions")
      +b.g-row.--appearance_nowrap.--align_center
        +b.g-cell.g-cols--6
          +b.P.ls-text.--size_2sm.--weight_bold {{ item.amount }} {{ _("грн") }}
        +b.g-cell.g-cols--6
          +b.BUTTON.ls-button--appearance_yellow.--width_full(
            @click.prevent="paymentConfirm([item.id])"
          ) {{ _("Оплатить") }}
  +b.ma.--top_md(v-if="objectItem.transactions.length === 1")
    +b.g-row.--justify_center
      +b.g-cell.g-cols--10
        +b.BUTTON.ls-button.--variant_accent-1(
          @click.prevent="$emit('close')"
        ) {{_('Отмена')}}
  +b.ma.--top_md(v-else)
    +b.g-row.--align_center
      +b.g-cell.g-cols--6
        +b.i-link.--color_accent-1(
          @click.prevent="$emit('close')"
        ) {{ _('Отмена') }}
      +b.g-cell.g-cols--6
        +b.BUTTON.ls-button.--variant_accent-1(
          @click.prevent="paymentAll"
        ) {{_('Оплатить все')}}
</template>

<script>
import {
  transactionPayResource,
} from '@/js/services/transaction.service'

export default {
  props: {
    objectItem: {},
  },

  data() {
    return {
      formdata: {},
      isLoad: false,
    }
  },

  methods: {
    paymentAll() {
      const ids = this.objectItem.transactions.map(el => el.id)
      this.paymentConfirm(ids)
    },

    paymentConfirm(idsTransaction) {
      const formdata = { idsTransaction }
      this.isLoad = true
      transactionPayResource.execute({}, formdata).then(res => {
        const { data: { item: { urlPay } } } = res
        window.location = urlPay
      }).finally(() => {
        this.isLoad = false
      })
    },
  },
}
</script>
